module.exports = "/_next/static/images/c28187bfcbd3b8537cff7199e2a0d72e-footer-sic-4x.png.webp";